export const DEFAULT_CATEGORIES = [
  { label: 'Food & dining', icon: '🍽', color: '#E85D3A' },
  { label: 'Groceries',     icon: '🛒', color: '#2D9B6F' },
  { label: 'Transport',     icon: '🚗', color: '#3A7BD5' },
  { label: 'Shopping',      icon: '🛍', color: '#9B59B6' },
  { label: 'Entertainment', icon: '🎬', color: '#F39C12' },
  { label: 'Health',        icon: '💊', color: '#E74C3C' },
  { label: 'Utilities',     icon: '💡', color: '#1ABC9C' },
  { label: 'Education',     icon: '📚', color: '#2980B9' },
  { label: 'Rent / EMI',    icon: '🏠', color: '#7F8C8D' },
  { label: 'Others',        icon: '📦', color: '#95A5A6' },
]

export const DEFAULT_MODES = [
  { label: 'UPI',          icon: '📱', color: '#1976D2' },
  { label: 'Cash',         icon: '💵', color: '#388E3C' },
  { label: 'Credit card',  icon: '💳', color: '#C62828' },
  { label: 'Debit card',   icon: '🏧', color: '#6A1B9A' },
  { label: 'Net banking',  icon: '🌐', color: '#00695C' },
  { label: 'Wallet',       icon: '👝', color: '#E65100' },
]

export const CATEGORY_COLORS = [
  '#E85D3A','#2D9B6F','#3A7BD5','#9B59B6','#F39C12',
  '#E74C3C','#1ABC9C','#2980B9','#7F8C8D','#D35400',
  '#8E44AD','#16A085','#C0392B','#27AE60','#2C3E50'
]

export const CATEGORY_EMOJIS = [
  // Food & dining
  '🍽','🍕','🍔','🥗','🍜','🥘','☕','🧃','🍰','🥪',
  // Groceries & household
  '🛒','🥛','🧴','🧹','💧','🧺','🛁','🍎','🥦','🧂',
  // Transport
  '🚗','🛵','🚌','✈️','⛽','🚕','🚂','🛺','🚲','🛥',
  // Health & medical
  '💊','🏥','🔬','🩺','🧪','💉','🩹','🦷','👓','🏃',
  // Education
  '📚','🎓','🖊','🎒','🖥','📐','🏫','📖','✏️','🎨',
  // Shopping & lifestyle
  '🛍','👗','👟','💄','⌚','📱','💻','🎧','📷','🪴',
  // Home & utilities
  '🏠','💡','🔌','🪣','🛋','🔑','🏗','🪟','🧱','🔧',
  // Entertainment
  '🎬','🎮','🎵','🏏','⚽','🎭','🎪','🎠','🃏','🎯',
  // Finance & others
  '💰','💳','🏦','📦','🎁','🤝','📋','🗂','💼','🧾',
  // Family & personal
  '👶','🐾','💈','💪','🧘','🏋️','🌿','🛀','🎀','🌺',
]

export const MODE_EMOJIS = ['📱','💵','💳','🏧','🌐','👝','🏦','📝','💸','🔄','🏪','💹','📲','🤝','💼']

// backward compat
export const CATEGORIES = DEFAULT_CATEGORIES
export const MODES = DEFAULT_MODES

export const CAT_MAP = Object.fromEntries(DEFAULT_CATEGORIES.map(c => [c.label, c]))
export const MODE_MAP = Object.fromEntries(DEFAULT_MODES.map(m => [m.label, m]))

export const MONTHS = [
  'January','February','March','April','May','June',
  'July','August','September','October','November','December'
]
